<template>

    <el-upload
      class="avatar-uploader upload"
      :action="imgurl()"
      list-type="picture-card"
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeAvatarUpload"
      :headers="headers"
    >
      <img v-if="imagesUrl" :src="imagesUrl" class="avatar" />
      <img v-else :src="loadImage('/cliupdata.png')" style="width:160px" />
    </el-upload>

</template>

<script>
    import {getToken} from "@/utils/auth";
    import axios from 'axios';

    export default {
        name: "index",
        props: {
            limit: {
                type: Number,
                default:10
            },
            value:{}
        },
        watch:{
            value:{
                immediate:true,
                handler:function(value){
                    if(!value){
                        this.fileList=[];
                        this.imagesUrl="";
                        return;
                    }

                    this.fileList=[{uid:"1",url:value}];
                    this.imagesUrl=value;
                }
            },
        },
        computed: {
            headers() {
                return {
                    "access-token": this.token // 直接从本地获取token就行
                };
            },

        },
        data() {
            return {token: getToken(), dialogVisible: false,imagesUrl:"",fileList:[]}
        },

        methods: {
            imgurl() {
                return axios.defaults.baseURL + "/common/updateLoad";
            },

            handleSuccess(res, file) {
                // debugger
                this.imagesUrl=res.data;
                this.$emit("input",this.imagesUrl)
                // console.log(res);
                // console.log(file);
                //   this.personage.identityFront = res.data;
            },



            // 图片格式要求
            beforeAvatarUpload(file) {
                const isPNG = file.type === "image/png";
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isPNG && !isJPG) {
                    this.$message.error(this.$t('上传图片只能是 JPG 格式和PNG格式!'));
                }
                if (!isLt2M) {
                    this.$message.error(this.$t('上传图片大小不能超过 2MB!'));
                }
                return isPNG || (isJPG && isLt2M);
            }
        }
    }
</script>

<style scoped>

  .avatar-uploader {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar {
    width: 160px;
    height: 158px;
    display: block;
    border-radius: 6px;
    border: 1px dashed #d9d9d9;
  }
</style>


// WEBPACK FOOTER //
// src/components/FSingleImageUpload/index.vue